import {
  Autocomplete,
  Box,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCredentials } from "../../../redux/actions/credentialAction";
import { getRegionsByAccount } from "../../../redux/actions/stateFileAction";
import { getPreviousMonths } from "../../../utils/timeUtils";
import { getDefaultAccount, getDefaultRegion } from "../utils";

const HomeToolbar = ({ state = {}, onChange }) => {
  const dispatch = useDispatch();
  const { allCredentials = [] } = useSelector((state) => state?.credential);
  const { allRegions } = useSelector((state) => state.stateFile);
  const [durationOptions, setDurationOptions] = useState([]);
  const [fetchingRegion, setFetchingRegion] = useState(false);
  const regionsOptions =
    allRegions.length > 0 ? [{ region: "All regions" }, ...allRegions] : [];

  useEffect(() => {
    dispatch(getAllCredentials());
    const last1Year = getPreviousMonths();
    onChange("month", last1Year[0]);
    setDurationOptions(last1Year);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (allCredentials?.length > 0) {
      const defaultAccount = getDefaultAccount(allCredentials);
      onChange("account", defaultAccount);
      fetchRegion(defaultAccount.credName);
    }
    //eslint-disable-next-line
  }, [allCredentials]);

  useEffect(() => {
    if (allRegions?.length > 0) {
      onChange("region", [getDefaultRegion(state?.account, allRegions)]);
    }
    //eslint-disable-next-line
  }, [allRegions]);

  const fetchRegion = (credName) => {
    setFetchingRegion(true);
    dispatch(getRegionsByAccount(credName, () => setFetchingRegion(false)));
  };

  const handleRegionChange = (value) => {
    const { region } = state;
    const isAllSelected = region.find((item) => item.region === "All regions");
    const isAllSelecting = value.find((item) => item.region === "All regions");

    if (isAllSelected && isAllSelecting) {
      onChange(
        "region",
        value.filter((item) => item.region !== "All regions")
      );
    } else if (!isAllSelected && isAllSelecting) {
      onChange("region", [{ region: "All regions" }]);
    } else {
      onChange("region", value);
    }
  };

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={4} md={3}>
          <Autocomplete
            disableClearable
            size="small"
            options={allCredentials}
            value={state?.account}
            fullWidth
            onChange={(e, value) => {
              onChange("account", value);
              fetchRegion(value.credName);
            }}
            getOptionLabel={(option) => option.accountNumber}
            renderInput={(params) => (
              <TextField {...params} margin="none" label="Select Account" />
            )}
          />
        </Grid>
        <Grid item xs={4} md={3}>
          <Autocomplete
            limitTags={1}
            multiple
            disableClearable={state?.region.length < 3}
            size="small"
            options={regionsOptions}
            value={state?.region}
            onChange={(e, value) => {
              handleRegionChange(value);
            }}
            getOptionLabel={(option) => option?.region}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="none"
                label="Select Region"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: fetchingRegion ? (
                    <CircularProgress color="primary" size={16} />
                  ) : (
                    params.InputProps.endAdornment
                  ),
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    display: "flex",
                    whiteSpace: "nowrap",
                    overflowX: "auto",
                    textOverflow: "ellipsis",
                    height: "40px",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={4} md={3}>
          <Autocomplete
            disableClearable
            size="small"
            options={durationOptions}
            value={state?.month}
            onChange={(e, value) => {
              onChange("month", value);
            }}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField {...params} margin="none" label="Select Month" />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomeToolbar;
